"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3470],{

/***/ 32118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SearchForm_Form; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Label/Label.js
var Label = __webpack_require__(98028);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Select/Select.js
var Select = __webpack_require__(16031);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/FormField/FormField.js + 1 modules
var FormField = __webpack_require__(55404);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Checkbox/Checkbox.js
var Checkbox = __webpack_require__(67905);
// EXTERNAL MODULE: ./node_modules/@pcln/date-picker/dist/esm/index.js + 92 modules
var esm = __webpack_require__(85577);
// EXTERNAL MODULE: ./src/components/StyledHeading/index.tsx
var StyledHeading = __webpack_require__(29293);
// EXTERNAL MODULE: ./src/components/CalenderWrapperBox.styled.ts
var CalenderWrapperBox_styled = __webpack_require__(2850);
// EXTERNAL MODULE: ./src/components/DateField.tsx
var DateField = __webpack_require__(43484);
// EXTERNAL MODULE: ./src/components/ShadowEffect.tsx
var ShadowEffect = __webpack_require__(10843);
// EXTERNAL MODULE: ./src/components/SearchFormButton/index.tsx
var SearchFormButton = __webpack_require__(17975);
// EXTERNAL MODULE: ./src/components/TypeAhead/index.tsx + 13 modules
var TypeAhead = __webpack_require__(21993);
// EXTERNAL MODULE: ./src/utils/date-helper.tsx
var date_helper = __webpack_require__(68511);
// EXTERNAL MODULE: ./src/components/Popover.tsx + 2 modules
var Popover = __webpack_require__(57812);
// EXTERNAL MODULE: ./src/components/TravelerSelection/constants.ts
var constants = __webpack_require__(45588);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/components/TravelerSelection/TravelerSelection.tsx + 9 modules
var TravelerSelection = __webpack_require__(47941);
// EXTERNAL MODULE: ./src/context/BootstrapDataContext.tsx
var BootstrapDataContext = __webpack_require__(68464);
// EXTERNAL MODULE: ./src/hooks/useTabGroup.ts
var useTabGroup = __webpack_require__(78474);
// EXTERNAL MODULE: ./src/hooks/useContentfulSearchFormHeadlines.ts
var useContentfulSearchFormHeadlines = __webpack_require__(98673);
// EXTERNAL MODULE: ./src/hooks/useSeti.ts
var useSeti = __webpack_require__(39939);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/utils.ts
var utils = __webpack_require__(360);
// EXTERNAL MODULE: ./src/components/Packages/SearchForm/TripTypes.ts
var TripTypes = __webpack_require__(51217);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Radio/Radio.js
var Radio = __webpack_require__(65753);
// EXTERNAL MODULE: ./node_modules/ramda/es/pipe.js + 5 modules
var pipe = __webpack_require__(71387);
// EXTERNAL MODULE: ./node_modules/ramda/es/set.js + 1 modules
var set = __webpack_require__(56892);
// EXTERNAL MODULE: ./node_modules/ramda/es/lensIndex.js + 1 modules
var lensIndex = __webpack_require__(12867);
;// CONCATENATED MODULE: ./src/utils/ramda-helper.ts

// eslint-disable-next-line import/prefer-default-export
function swap(index1, index2, list) {
    if (index1 < 0 || index2 < 0 || index1 > list.length - 1 || index2 > list.length - 1) {
        return list // index out of bound
        ;
    }
    return (0,pipe/* default */.Z)((0,set/* default */.Z)((0,lensIndex/* default */.Z)(index1), list[index2]), (0,set/* default */.Z)((0,lensIndex/* default */.Z)(index2), list[index1]))(list);
}

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/TripTypeRadios.tsx






var defaultTripTypes = Object.values(TripTypes/* TripTypeInfos */.jb);
var mobileDefaultTripTypes = swap(1, 2, defaultTripTypes);
var TripTypeRadios = function(param) {
    var setValue = param.setValue, watchTripType = param.watchTripType, register = param.register;
    var ref = (0,react.useContext)(BootstrapDataContext/* default */.Z), _isMobile = ref.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile;
    var tripTypes = isMobile ? mobileDefaultTripTypes : defaultTripTypes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        alignItems: [
            "left",
            null,
            "center"
        ],
        flexDirection: [
            "column",
            null,
            "row"
        ],
        justifyContent: "space-between",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            flexDirection: "row",
            flexWrap: "wrap",
            children: tripTypes.map(function(typeInfo) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    mr: [
                        0,
                        null,
                        3
                    ],
                    alignItems: "center",
                    width: isMobile ? 1 / 2 : "auto",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TripTypes/* TripTypeLabel */.sc, {
                        fontSize: 0,
                        fontWeight: 500,
                        nowrap: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                id: typeInfo.id,
                                type: "radio",
                                name: "tripType",
                                value: typeInfo.tripType,
                                ref: register,
                                checked: watchTripType === typeInfo.tripType,
                                onChange: function(e) {
                                    setValue("tripType", e.target.value);
                                }
                            }),
                            " ",
                            typeInfo.typeLabel
                        ]
                    })
                }, typeInfo.id);
            })
        })
    });
};
/* harmony default export */ var SearchForm_TripTypeRadios = (TripTypeRadios);

// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 31 modules
var es = __webpack_require__(57420);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/validation.ts


var LOCATION_REQUIRED = "Please enter a city or airport";
var INVALID_DATE = "Please select valid dates";
var DISALLOW_INFANT_INTL_FLIGHT = "Sorry, we do not offer lap infant seating on international flights";
var INFANT_CAPACITY_LIMIT = "Only one infant per adult is allowed";
var CHILD_AGE_REQUIRED = "Please enter children's age to get the best price for your group";
var TRAVELERS_PER_ROOM = 4;
var MAXIMUM_BUNDLE_GUEST_COUNT = 8;
var ROOM_CAPACITY_ERROR = "Rooms accommodate up to 4 people. You may need additional rooms for your group";
var BUNDLE_MAX_CAPACITY_ERROR = "Bundles accommodate up to 8 people. You may need an additional bundle for your group";
var intlStartLocation = function(startLocationObject) {
    return startLocationObject && typeof startLocationObject.countryCode === "string" && startLocationObject.countryCode.toUpperCase() !== "US";
};
var intlEndLocation = function(endLocationObject) {
    return endLocationObject && typeof endLocationObject.countryCode === "string" && endLocationObject.countryCode.toUpperCase() !== "US";
};
var isInfantFound = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.some(function(age) {
        return Number(age) === 0;
    });
};
var isStartLocationWithInfant = function(startLocationObject, childrenAges) {
    return intlStartLocation(startLocationObject) && isInfantFound(childrenAges);
};
var isEndLocationWithInfant = function(endLocationObject, childrenAges) {
    return intlEndLocation(endLocationObject) && isInfantFound(childrenAges);
};
var isChildrenAgeDataValid = function(childrenAges) {
    return Array.isArray(childrenAges) && childrenAges.length >= 0;
};
var numOfValidAges = function(childrenAges) {
    return Array.isArray(childrenAges) ? childrenAges.filter(function(age) {
        return age >= 0;
    }) : [];
};
var isInfantOnInternationalTravel = function(startLocation, endLocation, childrenAges) {
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return DISALLOW_INFANT_INTL_FLIGHT;
    }
    return "";
};
function handleIsInfantOnInternationalTravel() {
    var _parent = this.parent, startLocation = _parent.startLocation, endLocation = _parent.endLocation, childrenAges = _parent.childrenAges;
    if (isStartLocationWithInfant(startLocation, childrenAges) || isEndLocationWithInfant(endLocation, childrenAges)) {
        return false;
    }
    return true;
}
var isRoomCompacityReached = function(adultCount, childrenCount, tripType, roomCount, isMoreRoomCapacityAllowed) {
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = isMoreRoomCapacityAllowed ? MAXIMUM_BUNDLE_GUEST_COUNT : roomCount * TRAVELERS_PER_ROOM;
    if (allowedTravelerCount < travelerCount && tripType.includes(TripTypes/* HOTEL */.IN)) {
        return isMoreRoomCapacityAllowed ? BUNDLE_MAX_CAPACITY_ERROR : ROOM_CAPACITY_ERROR;
    }
    return "";
};
function handleIsRoomCompacityReached() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenCount = _parent.childrenCount, tripType = _parent.tripType, roomCount = _parent.roomCount;
    var ref = this.options.context || {}, _isMoreRoomCapacityAllowed = ref.isMoreRoomCapacityAllowed, isMoreRoomCapacityAllowed = _isMoreRoomCapacityAllowed === void 0 ? false : _isMoreRoomCapacityAllowed;
    var travelerCount = adultCount + childrenCount;
    var allowedTravelerCount = isMoreRoomCapacityAllowed ? MAXIMUM_BUNDLE_GUEST_COUNT : roomCount * TRAVELERS_PER_ROOM;
    if (allowedTravelerCount < travelerCount && tripType.includes(TripTypes/* HOTEL */.IN)) {
        return false;
    }
    return true;
}
function handleIsChildrenAgeProvided() {
    var _parent = this.parent, childrenCount = _parent.childrenCount, childrenAges = _parent.childrenAges;
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return false;
    }
    return true;
}
var isChildrenAgeProvided = function(childrenCount, childrenAges) {
    if (childrenCount > 0 && isChildrenAgeDataValid(childrenAges) && childrenCount !== numOfValidAges(childrenAges).length) {
        return CHILD_AGE_REQUIRED;
    }
    return "";
};
var isInfantLimitReachedPackages = function(adultCount, childrenAges, tripType) {
    var lapInfants = childrenAges.filter(function(age) {
        return age === 0;
    });
    var infantCount = lapInfants.length;
    if (tripType.includes(TripTypes/* FLIGHT */.qQ) && infantCount > adultCount) {
        return INFANT_CAPACITY_LIMIT;
    }
    return "";
};
function handleIsInfantLimitReachedPackage() {
    var _parent = this.parent, adultCount = _parent.adultCount, childrenAges = _parent.childrenAges, tripType = _parent.tripType;
    if (isInfantLimitReachedPackages(adultCount, childrenAges, tripType)) {
        return false;
    }
    return true;
}
var searchFormSchema = es/* object */.Ry().shape({
    tripType: es/* string */.Z_(),
    partialStay: es/* bool */.Xg(),
    startLocation: es/* object */.Ry().nullable().when("tripType", {
        is: TripTypes/* STAY_DRIVE */.Hl,
        then: es/* object */.Ry().nullable(),
        otherwise: es/* object */.Ry().nullable().required(LOCATION_REQUIRED)
    }),
    endLocation: es/* object */.Ry().nullable().required(LOCATION_REQUIRED),
    rcLocation: es/* object */.Ry().nullable().when("pickupCarSomewhere", {
        is: true,
        then: es/* object */.Ry().nullable().required(LOCATION_REQUIRED),
        otherwise: es/* object */.Ry().nullable()
    }),
    startDate: es/* string */.Z_().required(INVALID_DATE),
    endDate: es/* string */.Z_().required(INVALID_DATE),
    hotelStartDate: es/* string */.Z_().when("partialStay", {
        is: true,
        then: es/* string */.Z_().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    hotelEndDate: es/* string */.Z_().when("partialStay", {
        is: true,
        then: es/* string */.Z_().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    rcPickupDate: es/* string */.Z_().when("pickupCarSomewhere", {
        is: true,
        then: es/* string */.Z_().nullable().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    rcDropoffDate: es/* string */.Z_().when("pickupCarSomewhere", {
        is: true,
        then: es/* string */.Z_().nullable().required(INVALID_DATE),
        otherwise: es/* string */.Z_()
    }),
    isInfantOnInternationalTravel: es/* string */.Z_().test("isInfantOnInternationalTravel", DISALLOW_INFANT_INTL_FLIGHT, handleIsInfantOnInternationalTravel),
    isChildrenAgeProvided: es/* string */.Z_().test("isChildrenAgeProvided", CHILD_AGE_REQUIRED, handleIsChildrenAgeProvided),
    isRoomCompacityReached: es/* string */.Z_().test("isRoomCompacityReached", ROOM_CAPACITY_ERROR, handleIsRoomCompacityReached),
    isInfantLimitReachedPackages: es/* string */.Z_().test("isInfantLimitReachedPackages", INFANT_CAPACITY_LIMIT, handleIsInfantLimitReachedPackage)
});

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/react-hook-form.es.js
var react_hook_form_es = __webpack_require__(63523);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@pcln/experimentation/dist/esm/index.js + 4 modules
var dist_esm = __webpack_require__(80460);
// EXTERNAL MODULE: ./src/constants/analytics.ts
var constants_analytics = __webpack_require__(66487);
// EXTERNAL MODULE: ./src/utils/packages-room-count.ts
var packages_room_count = __webpack_require__(40753);
;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/FormContainer.tsx








var HOTEL = "STAY";
function FormContainer(param) {
    var children = param.children, initialState = param.initialState, onSubmit = param.onSubmit, fields = param.fields, searchFormSchema = param.searchFormSchema, isMoreRoomCapacityAllowed = param.isMoreRoomCapacityAllowed;
    var ref = (0,react_hook_form_es/* useForm */.cI)({
        defaultValues: initialState,
        mode: "onSubmit",
        validationSchema: searchFormSchema,
        reValidateMode: "onChange",
        validationContext: {
            isMoreRoomCapacityAllowed: isMoreRoomCapacityAllowed
        }
    }), register = ref.register, unregister = ref.unregister, setValue = ref.setValue, clearError = ref.clearError, formState = ref.formState, handleSubmit = ref.handleSubmit, watch = ref.watch, errors = ref.errors;
    (0,react.useEffect)(function() {
        fields.forEach(function(name) {
            register({
                name: name
            });
        });
        return function() {
            fields.forEach(function(name) {
                unregister(name);
            });
        };
    }, [
        fields,
        register,
        unregister
    ]);
    var ref1 = watch(), watchTripType = ref1.tripType, watchPartialStay = ref1.partialStay, watchStartLocation = ref1.startLocation, watchEndLocation = ref1.endLocation, watchStartDate = ref1.startDate, watchEndDate = ref1.endDate, watchRoomCount = ref1.roomCount, watchAdultCount = ref1.adultCount, watchChildrenAges = ref1.childrenAges, watchChildrenCount = ref1.childrenCount, watchHotelStartDate = ref1.hotelStartDate, watchHotelEndDate = ref1.hotelEndDate, watchPickupCarSomewhere = ref1.pickupCarSomewhere, watchPickupCarIncludeAirport = ref1.pickupCarIncludeAirport, watchRcLocation = ref1.rcLocation, watchRcPickupDate = ref1.rcPickupDate, watchRcDropoffDate = ref1.rcDropoffDate, watchRcPickupTime = ref1.rcPickupTime, watchRcDropoffTime = ref1.rcDropoffTime, watchGaCategory = ref1.gaCategory;
    // PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION
    (0,react.useEffect)(function() {
        if (watchTripType.includes(HOTEL) && (0,packages_room_count/* default */.Z)(watchRoomCount, watchAdultCount + watchChildrenCount)) {
            dist_esm/* default.fireImpression */.Z.fireImpression("PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION");
        }
    }, [
        watchTripType,
        watchRoomCount,
        watchAdultCount,
        watchChildrenCount
    ]);
    (0,react.useEffect)(function() {
        clearError("startLocation");
    }, [
        clearError,
        watchStartLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("endLocation");
    }, [
        clearError,
        watchEndLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("rcLocation");
    }, [
        clearError,
        watchRcLocation
    ]);
    (0,react.useEffect)(function() {
        clearError("startDate");
    }, [
        clearError,
        watchStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError("endDate");
    }, [
        clearError,
        watchEndDate
    ]);
    (0,react.useEffect)(function() {
        clearError("hotelStartDate");
    }, [
        clearError,
        watchHotelStartDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearError("hotelEndDate");
    }, [
        clearError,
        watchHotelEndDate,
        watchPartialStay
    ]);
    (0,react.useEffect)(function() {
        clearError("hotelStartDateInRange");
    }, [
        clearError,
        watchPartialStay,
        watchStartDate,
        watchHotelStartDate
    ]);
    (0,react.useEffect)(function() {
        clearError("hotelEndDateInRange");
    }, [
        clearError,
        watchPartialStay,
        watchEndDate,
        watchHotelEndDate
    ]);
    (0,react.useEffect)(function() {
        clearError("rcPickupDate");
    }, [
        clearError,
        watchRcPickupDate
    ]);
    (0,react.useEffect)(function() {
        clearError("rcDropoffDate");
    }, [
        clearError,
        watchRcDropoffDate
    ]);
    (0,react.useEffect)(function() {
        clearError("isInfantOnInternationalTravel");
    }, [
        clearError,
        watchStartLocation,
        watchEndLocation,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearError("isChildrenAgeProvided");
    }, [
        clearError,
        watchChildrenCount,
        watchChildrenAges
    ]);
    (0,react.useEffect)(function() {
        clearError("isRoomCompacityReached");
    }, [
        clearError,
        watchAdultCount,
        watchChildrenCount,
        watchTripType,
        watchRoomCount
    ]);
    (0,react.useEffect)(function() {
        if (watchPickupCarSomewhere) clearError("rcDropoffDate");
    }, [
        clearError,
        watchPickupCarSomewhere
    ]);
    var pathname = (0,router.useRouter)().pathname;
    var ANALYTICS_CATEGORY = constants_analytics/* ANALYTICS_CATEGORIES */.ZP[pathname];
    (0,react.useEffect)(function() {
        setValue("gaCategory", ANALYTICS_CATEGORY);
    }, [
        setValue,
        ANALYTICS_CATEGORY
    ]);
    (0,react.useEffect)(function() {
        if (formState.submitCount && !formState.isValid) {
            analytics/* default.fireEvent */.Z.fireEvent({
                category: ANALYTICS_CATEGORY,
                action: "VP Search Button",
                label: constants_analytics/* INVALID */.UI
            });
        }
    }, [
        formState.isValid,
        formState.submitCount,
        ANALYTICS_CATEGORY
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
        "aria-label": "packages-search-form",
        onSubmit: handleSubmit(onSubmit),
        children: children({
            setValue: setValue,
            errors: errors,
            register: register,
            watchState: {
                watchTripType: watchTripType,
                watchAdultCount: watchAdultCount,
                watchRoomCount: watchRoomCount,
                watchChildrenAges: watchChildrenAges,
                watchChildrenCount: watchChildrenCount,
                watchHotelStartDate: watchHotelStartDate,
                watchHotelEndDate: watchHotelEndDate,
                watchStartDate: watchStartDate,
                watchEndDate: watchEndDate,
                watchPartialStay: watchPartialStay,
                watchStartLocation: watchStartLocation,
                watchEndLocation: watchEndLocation,
                watchPickupCarSomewhere: watchPickupCarSomewhere,
                watchPickupCarIncludeAirport: watchPickupCarIncludeAirport,
                watchRcLocation: watchRcLocation,
                watchRcPickupDate: watchRcPickupDate,
                watchRcDropoffDate: watchRcDropoffDate,
                watchRcPickupTime: watchRcPickupTime,
                watchRcDropoffTime: watchRcDropoffTime,
                watchGaCategory: watchGaCategory
            }
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Packages/SearchForm/Form.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  &::-ms-expand {\n    display: none;\n  }\n  cursor: pointer;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


























var InlineBlockBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-ab958ce4-0"
})(_templateObject());
var FlexLabel = (0,styled_components_browser_esm/* default */.ZP)(Label/* default */.Z).withConfig({
    componentId: "sc-ab958ce4-1"
})(_templateObject1());
var trackOneWayFlightLinkClick = function() {
    analytics/* default.fireEvent */.Z.fireEvent({
        action: "Search Form Link",
        label: "I need a one-way flight"
    });
};
var StyledSelect = (0,styled_components_browser_esm/* default */.ZP)(Select/* default */.Z).withConfig({
    componentId: "sc-ab958ce4-2"
})(_templateObject2(), theme/* theme.colors.white */.rS.colors.white);
var TimeField = function(_param) /*#__PURE__*/ {
    var name = _param.name, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "name",
        "label"
    ]);
    return (0,jsx_runtime.jsxs)(FormField/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSelect, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                id: name,
                name: name,
                children: (0,date_helper/* getTimeOptions */.wU)()
            }))
        ]
    });
};
var formatOneWayHref = function(param) {
    var watchTripType = param.watchTripType, startLocation = param.watchStartLocation, endLocation = param.watchEndLocation, watchStartDate = param.watchStartDate, watchEndDate = param.watchEndDate, watchRoomCount = param.watchRoomCount, watchAdultCount = param.watchAdultCount, watchChildrenCount = param.watchChildrenCount, watchChildrenAges = param.watchChildrenAges, watchHotelStartDate = param.watchHotelStartDate, watchHotelEndDate = param.watchHotelEndDate, watchPartialStay = param.watchPartialStay;
    var stringifiedQuery = query_string.stringify((0,_object_spread/* default */.Z)({
        "flight-code": "OW",
        "trip-type": watchTripType,
        "origin-item": startLocation === null || startLocation === void 0 ? void 0 : startLocation.itemName,
        "origin-id": startLocation === null || startLocation === void 0 ? void 0 : startLocation.id,
        "origin-type": startLocation === null || startLocation === void 0 ? void 0 : startLocation.type,
        "origin-city": startLocation === null || startLocation === void 0 ? void 0 : startLocation.cityName,
        "origin-state": startLocation === null || startLocation === void 0 ? void 0 : startLocation.provinceName,
        "origin-state-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.stateCode,
        "origin-country": startLocation === null || startLocation === void 0 ? void 0 : startLocation.country,
        "origin-country-code": startLocation === null || startLocation === void 0 ? void 0 : startLocation.countryCode,
        "destination-item": endLocation === null || endLocation === void 0 ? void 0 : endLocation.itemName,
        "destination-id": endLocation === null || endLocation === void 0 ? void 0 : endLocation.id,
        "destination-type": endLocation === null || endLocation === void 0 ? void 0 : endLocation.type,
        "destination-city": endLocation === null || endLocation === void 0 ? void 0 : endLocation.cityName,
        "destination-state": endLocation === null || endLocation === void 0 ? void 0 : endLocation.provinceName,
        "destination-state-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.stateCode,
        "destination-country": endLocation === null || endLocation === void 0 ? void 0 : endLocation.country,
        "destination-country-code": endLocation === null || endLocation === void 0 ? void 0 : endLocation.countryCode,
        start: watchStartDate,
        end: watchEndDate,
        rooms: watchRoomCount,
        adults: watchAdultCount,
        children: watchChildrenCount,
        ages: JSON.stringify(watchChildrenAges)
    }, watchPartialStay ? {
        "hotel-start": watchHotelStartDate,
        "hotel-end": watchHotelEndDate
    } : {}));
    return "/shop/search/trips/?".concat(stringifiedQuery);
};
var Form = function(param) {
    var onSubmit = param.onSubmit, _isLandingPage = param.isLandingPage, isLandingPage = _isLandingPage === void 0 ? true : _isLandingPage;
    var ref = (0,useTabGroup/* default */.Z)(), registerTabElement = ref.registerTabElement, focusNextElement = ref.focusNextElement;
    var ref1 = (0,react.useContext)(BootstrapDataContext/* default */.Z), customer = ref1.customer, _isMobile = ref1.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, webstats = ref1.webstats;
    var ref2 = (0,react.useState)(false), isCalendarOpen = ref2[0], setIsCalendarOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isRcPickupCalendarOpen = ref3[0], setIsRcPickupCalendarOpen = ref3[1];
    var ref4 = (0,react.useState)(false), isRcDropoffCalendarOpen = ref4[0], setIsRcDropoffCalendarOpen = ref4[1];
    var ref5 = (0,react.useState)(false), isHotelCalendarOpen = ref5[0], setIsHotelCalendarOpen = ref5[1];
    var primaryHeadingText = "Save up to $625 on your ";
    var secondaryHeadingText = !isMobile ? "Book together for our best deals" : "";
    var buttonText = "Find Your Trip";
    var callToAction = "Book a hotel, flight or car with free cancellation for flexibility";
    var radioExperimentInitialState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils/* initialState */.E3), {
        tripType: TripTypes/* STAY_FLY */.b
    });
    var searchForm = (0,useContentfulSearchFormHeadlines/* default */.Z)("searchForm");
    var isMoreRoomCapacityAllowed = (0,useSeti/* default */.Z)("PKG_FE_SEARCH_FORM_HOTEL_NUM_ADULTS_RESTRICTION", false) === "VARIANT";
    var HTL_MAX_DAYS_ALLOWED = (0,useSeti/* default */.Z)("HTL_MAX_DAYS_ALLOWED", false);
    var maxDaysHotelToSelect = HTL_MAX_DAYS_ALLOWED === "VARIANT" ? 32 : 30;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormContainer, {
        onSubmit: onSubmit,
        fields: utils/* fields */.XU,
        initialState: radioExperimentInitialState,
        searchFormSchema: searchFormSchema,
        isMoreRoomCapacityAllowed: isMoreRoomCapacityAllowed,
        children: function(param) {
            var setValue = param.setValue, errors = param.errors, register = param.register, _watchState = param.watchState, watchTripType = _watchState.watchTripType, watchAdultCount = _watchState.watchAdultCount, watchRoomCount = _watchState.watchRoomCount, watchChildrenAges = _watchState.watchChildrenAges, watchChildrenCount = _watchState.watchChildrenCount, watchHotelStartDate = _watchState.watchHotelStartDate, watchHotelEndDate = _watchState.watchHotelEndDate, watchStartDate = _watchState.watchStartDate, watchEndDate = _watchState.watchEndDate, watchPartialStay = _watchState.watchPartialStay, watchStartLocation = _watchState.watchStartLocation, watchEndLocation = _watchState.watchEndLocation, watchPickupCarSomewhere = _watchState.watchPickupCarSomewhere, watchRcLocation = _watchState.watchRcLocation, watchRcPickupDate = _watchState.watchRcPickupDate, watchRcDropoffDate = _watchState.watchRcDropoffDate, watchRcPickupTime = _watchState.watchRcPickupTime, watchRcDropoffTime = _watchState.watchRcDropoffTime;
            var finalPrimaryHeadingText = (0,utils/* getTextString */.GS)(watchTripType)(primaryHeadingText);
            var contentfulHeadline = isMobile ? searchForm === null || searchForm === void 0 ? void 0 : searchForm.mobileHeadline : searchForm === null || searchForm === void 0 ? void 0 : searchForm.headline;
            var contentfulSubheadline = isMobile ? searchForm === null || searchForm === void 0 ? void 0 : searchForm.mobileSubheadline : searchForm === null || searchForm === void 0 ? void 0 : searchForm.subheadline;
            var headline = contentfulHeadline || finalPrimaryHeadingText;
            var subheadline = contentfulSubheadline || secondaryHeadingText;
            var carLocationLabel = "City, Airport or Address";
            var rudderstack = {
                "data-rudder-event": true,
                "data-sub-type": "search",
                "data-cguid": webstats.clientGUID,
                "data-parent-product": watchTripType,
                "data-source": isLandingPage ? "package landing" : "homepage",
                "data-email-address": customer.emailAddress
            };
            var maxDaysToSelect = !(0,TripTypes/* hasHotel */.$l)(watchTripType) ? 330 : maxDaysHotelToSelect;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    isLandingPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                pb: 1,
                                tag: "h1",
                                color: "text.heading",
                                text: headline,
                                textStyle: [
                                    "heading3",
                                    null,
                                    null,
                                    null,
                                    "heading2"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading/* default */.Z, {
                                pb: 3,
                                tag: "h2",
                                color: "text.light",
                                text: subheadline,
                                textStyle: [
                                    "subheading6",
                                    null,
                                    null,
                                    null,
                                    "subheading4"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchForm_TripTypeRadios, {
                                watchTripType: watchTripType,
                                setValue: setValue,
                                register: register
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                mx: -2,
                                children: [
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            1 / 2
                                        ],
                                        px: 2,
                                        mt: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "startLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesOrigin",
                                                    label: "Where from?",
                                                    placeholder: "Where from?",
                                                    searchKey: "startLocation",
                                                    setValue: setValue,
                                                    errors: errors,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchStartLocation,
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? 1 : 1 / 2
                                        ],
                                        px: 2,
                                        mt: 3,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                            enabled: true,
                                            forProperty: "endLocation",
                                            children: function(param) {
                                                var disableShadowState = param.disableShadowState;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                    searchProduct: "packagesDestination",
                                                    label: "Where to?",
                                                    placeholder: "Where to?",
                                                    searchKey: "endLocation",
                                                    errors: errors,
                                                    setValue: setValue,
                                                    disableShadowState: disableShadowState,
                                                    defaultSelectedItem: watchEndLocation,
                                                    onItemSelect: function(item) {
                                                        // auto-populate RC location if not set yet
                                                        if (!watchRcLocation) {
                                                            setValue("rcLocation", item);
                                                        }
                                                    },
                                                    ref: registerTabElement,
                                                    focusNextElement: focusNextElement
                                                });
                                            }
                                        })
                                    })
                                ]
                            }),
                            watchTripType.includes("FLY") && /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineBlockBox, {
                                mt: 3,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    href: formatOneWayHref({
                                        watchTripType: watchTripType,
                                        watchStartLocation: watchStartLocation,
                                        watchEndLocation: watchEndLocation,
                                        watchStartDate: watchStartDate,
                                        watchEndDate: watchEndDate,
                                        watchRoomCount: watchRoomCount,
                                        watchAdultCount: watchAdultCount,
                                        watchChildrenCount: watchChildrenCount,
                                        watchChildrenAges: watchChildrenAges,
                                        watchHotelStartDate: watchHotelStartDate,
                                        watchHotelEndDate: watchHotelEndDate,
                                        watchPartialStay: watchPartialStay
                                    }),
                                    target: "_blank",
                                    onClick: trackOneWayFlightLinkClick,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontWeight: "bold",
                                        children: "I need a one-way flight"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                                mx: -2,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            2 / 3
                                        ],
                                        flexWrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                px: 2,
                                                mt: 3,
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "startDate",
                                                    children: function(param) {
                                                        var disableShadowState = param.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                            "data-calendar": true,
                                                            open: isCalendarOpen,
                                                            onDismiss: function() {
                                                                setIsCalendarOpen(false);
                                                                disableShadowState();
                                                            },
                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                    name: "travelDates",
                                                                    "data-testid": "packages-date-range",
                                                                    label: (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) ? "Check-in   -   Check-out" : "Departing - Returning",
                                                                    ref: registerTabElement,
                                                                    value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                        startDate: watchStartDate,
                                                                        endDate: watchEndDate
                                                                    }),
                                                                    onFocus: function() {
                                                                        setIsCalendarOpen(true);
                                                                    },
                                                                    error: function() {
                                                                        if (errors.startDate) {
                                                                            return errors.startDate.message;
                                                                        }
                                                                        if (errors.endDate) {
                                                                            return errors.endDate.message;
                                                                        }
                                                                    }(),
                                                                    hideTooltip: false,
                                                                    isMobile: isMobile,
                                                                    "aria-expanded": isCalendarOpen ? "true" : "false"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                    monthWidth: 300,
                                                                    startDate: watchStartDate,
                                                                    endDate: watchEndDate,
                                                                    maxDaysToSelect: maxDaysToSelect,
                                                                    onChange: function(_, param) {
                                                                        var startDate = param.startDate, endDate = param.endDate;
                                                                        if (startDate && endDate) {
                                                                            setIsCalendarOpen(false);
                                                                            disableShadowState();
                                                                        }
                                                                        setValue("startDate", startDate || "");
                                                                        setValue("endDate", endDate || "");
                                                                        setValue("hotelStartDate", startDate || "");
                                                                        setValue("hotelEndDate", endDate || "");
                                                                        // auto-populate RC dates if not set yet
                                                                        if (!watchRcPickupDate) setValue("rcPickupDate", startDate);
                                                                        if (!watchRcDropoffDate) setValue("rcDropoffDate", endDate);
                                                                    },
                                                                    useDefaultFooter: true,
                                                                    onDismiss: function() {
                                                                        setIsCalendarOpen(false);
                                                                        disableShadowState();
                                                                    }
                                                                })
                                                            ]
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                px: 2,
                                                mt: 3,
                                                width: [
                                                    1,
                                                    null,
                                                    1 / 2
                                                ],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                    enabled: true,
                                                    forProperty: "travelers-selection-readonly-input",
                                                    alternativeBlurHandling: true,
                                                    children: function(param) {
                                                        var disableShadowState = param.disableShadowState;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelerSelection/* default */.Z, {
                                                            disclaimer: constants/* VP_DISCLAIMER */.sP,
                                                            onDoneButtonClick: disableShadowState,
                                                            roomCount: watchRoomCount,
                                                            adultCount: watchAdultCount,
                                                            childrenAges: watchChildrenAges,
                                                            childrenCount: watchChildrenCount,
                                                            showChildAgeSelectors: true,
                                                            showRoomMenuItem: (0,TripTypes/* hasHotel */.$l)(watchTripType),
                                                            showSubLabel: false,
                                                            setValue: setValue,
                                                            disableShadowState: disableShadowState,
                                                            isMobile: isMobile,
                                                            error: isInfantOnInternationalTravel(watchStartLocation, watchEndLocation, watchChildrenAges) || isInfantLimitReachedPackages(watchAdultCount, watchChildrenAges, watchTripType) || isChildrenAgeProvided(watchChildrenCount, watchChildrenAges) || isRoomCompacityReached(watchAdultCount, watchChildrenCount, watchTripType, watchRoomCount, isMoreRoomCapacityAllowed),
                                                            infantCount: 0,
                                                            showInfantMenuItem: false,
                                                            showYouthMenuItem: false,
                                                            youthCount: 0
                                                        });
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                mt: 2,
                                                width: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        ml: 1,
                                                        flexWrap: [
                                                            "wrap",
                                                            null,
                                                            "nowrap"
                                                        ],
                                                        children: !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && (0,TripTypes/* hasHotel */.$l)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                            nowrap: true,
                                                            fontSize: 0,
                                                            mr: 2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                    id: "packages-partial-stay",
                                                                    name: "partialStay",
                                                                    ref: register
                                                                }),
                                                                " ",
                                                                "I only need a hotel for part of my stay"
                                                            ]
                                                        })
                                                    }),
                                                    watchPartialStay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        mt: 2,
                                                        px: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                            enabled: true,
                                                            forProperty: "hotelDates",
                                                            children: function(param) {
                                                                var disableShadowState = param.disableShadowState;
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                    "data-hotel-calendar": "true",
                                                                    domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                    onDismiss: function() {
                                                                        setIsHotelCalendarOpen(false);
                                                                        disableShadowState();
                                                                    },
                                                                    open: isHotelCalendarOpen,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                            "aria-expanded": isHotelCalendarOpen ? "true" : "false",
                                                                            error: function() {
                                                                                if (errors.hotelStartDate) {
                                                                                    return errors.hotelStartDate.message;
                                                                                }
                                                                                if (errors.hotelEndDate) {
                                                                                    return errors.hotelEndDate.message;
                                                                                }
                                                                                if (errors.hotelStartDateInRange) {
                                                                                    return errors.hotelStartDateInRange.message;
                                                                                }
                                                                                if (errors.hotelEndDateInRange) {
                                                                                    return errors.hotelEndDateInRange.message;
                                                                                }
                                                                            }(),
                                                                            isMobile: isMobile,
                                                                            label: "Check-in - Check-out",
                                                                            name: "hotelDates",
                                                                            onFocus: function() {
                                                                                setIsHotelCalendarOpen(true);
                                                                            },
                                                                            value: (0,date_helper/* getPackagesDateRange */.Q0)({
                                                                                startDate: watchHotelStartDate !== null && watchHotelStartDate !== void 0 ? watchHotelStartDate : null,
                                                                                endDate: watchHotelEndDate !== null && watchHotelEndDate !== void 0 ? watchHotelEndDate : null
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                            startDate: watchHotelStartDate,
                                                                            endDate: watchHotelEndDate,
                                                                            maxDate: watchEndDate ? (0,date_helper/* addFormattedDays */.r2)(watchEndDate, 1) : date_helper/* defaultMaxDate */.Vo,
                                                                            minDate: watchStartDate || date_helper/* defaultToday */.G4,
                                                                            maxDaysToSelect: maxDaysToSelect,
                                                                            monthWidth: 300,
                                                                            onChange: function(_, param) {
                                                                                var startDate = param.startDate, endDate = param.endDate;
                                                                                if (startDate && endDate) {
                                                                                    setIsHotelCalendarOpen(false);
                                                                                    disableShadowState();
                                                                                }
                                                                                setValue("hotelStartDate", startDate || "");
                                                                                setValue("hotelEndDate", endDate || "");
                                                                            },
                                                                            monthsToShow: watchStartDate && watchEndDate ? 1 : 2,
                                                                            onDismiss: function() {
                                                                                setIsHotelCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            useDefaultFooter: true
                                                                        })
                                                                    ]
                                                                });
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexWrap: "wrap",
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                mt: 2,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                    nowrap: true,
                                                    fontSize: 0,
                                                    ml: 1,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                            id: "packages-pickup-car-somewhere",
                                                            "data-testid": "packages-pickup-car-somewhere",
                                                            name: "pickupCarSomewhere",
                                                            ref: register
                                                        }),
                                                        " ",
                                                        "I want to pick up my car somewhere else"
                                                    ]
                                                })
                                            }),
                                            watchPickupCarSomewhere && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                alignItems: "flex-start",
                                                width: [
                                                    1,
                                                    null,
                                                    1
                                                ],
                                                px: 2,
                                                mt: 2,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                        enabled: true,
                                                        forProperty: "rcLocation",
                                                        children: function(param) {
                                                            var disableShadowState = param.disableShadowState;
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
                                                                searchProduct: "cars",
                                                                label: carLocationLabel,
                                                                placeholder: carLocationLabel,
                                                                searchKey: "rcLocation",
                                                                "data-testid": "packages-rc-location",
                                                                errors: errors,
                                                                setValue: setValue,
                                                                disableShadowState: disableShadowState,
                                                                defaultSelectedItem: watchRcLocation !== null && watchRcLocation !== void 0 ? watchRcLocation : null,
                                                                ref: registerTabElement,
                                                                focusNextElement: focusNextElement
                                                            });
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                                        mt: 2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexLabel, {
                                                            nowrap: true,
                                                            fontSize: 0,
                                                            ml: -2,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                                    id: "packages-pickup-car-include-airport",
                                                                    name: "pickupCarIncludeAirport",
                                                                    ref: register
                                                                }),
                                                                " ",
                                                                "Include airport pick-up and drop-off locations"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                        flexWrap: "wrap",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                "data-testid": "packages-rc-pickup-date",
                                                                id: "rc-pickup-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupDate",
                                                                    children: function(param) {
                                                                        var disableShadowState = param.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcPickupCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcPickupCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcPickupDate",
                                                                                    label: "Pick-up",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcPickupDate !== null && watchRcPickupDate !== void 0 ? watchRcPickupDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcPickupCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcPickupDate) {
                                                                                            return errors.rcPickupDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    isMobile: isMobile,
                                                                                    "aria-expanded": isRcPickupCalendarOpen ? "true" : "false"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    monthsToShow: 2,
                                                                                    selectTwoDates: false,
                                                                                    maxDate: (0,date_helper/* getRcMaxDate */.U6)(watchRcDropoffDate),
                                                                                    startDate: watchRcPickupDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcPickupCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue("rcPickupDate", startDate || "");
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcPickupCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcPickupTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-pickup-time",
                                                                        "data-testid": "packages-rc-pickup-time",
                                                                        name: "rcPickupTime",
                                                                        label: "Pick-up Time",
                                                                        ref: register,
                                                                        style: {
                                                                            height: isMobile ? "46px" : "56px"
                                                                        },
                                                                        value: watchRcPickupTime,
                                                                        onChange: function(e) {
                                                                            setValue("rcPickupTime", e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CalenderWrapperBox_styled/* default */.Z, {
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                id: "rc-dropoff-date",
                                                                "data-testid": "packages-rc-dropoff-date",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffDate",
                                                                    children: function(param) {
                                                                        var disableShadowState = param.disableShadowState;
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Popover/* PopoverContainer */.OI, {
                                                                            "data-calendar": true,
                                                                            open: isRcDropoffCalendarOpen,
                                                                            onDismiss: function() {
                                                                                setIsRcDropoffCalendarOpen(false);
                                                                                disableShadowState();
                                                                            },
                                                                            domSelectorForVisuallyContainedElement: utils/* CALENDAR_POPOVER_SELECTOR */.k7,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                                                    name: "rcDropoffDate",
                                                                                    label: "Drop-off",
                                                                                    ref: registerTabElement,
                                                                                    value: (0,date_helper/* formatDate */.p6)(watchRcDropoffDate !== null && watchRcDropoffDate !== void 0 ? watchRcDropoffDate : null),
                                                                                    onFocus: function() {
                                                                                        setIsRcDropoffCalendarOpen(true);
                                                                                    },
                                                                                    error: function() {
                                                                                        if (errors.rcDropoffDate) {
                                                                                            return errors.rcDropoffDate.message;
                                                                                        }
                                                                                    }(),
                                                                                    hideTooltip: false,
                                                                                    isMobile: isMobile,
                                                                                    "aria-expanded": isRcDropoffCalendarOpen ? "true" : "false"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Calendar */.f, {
                                                                                    monthsToShow: 2,
                                                                                    selectTwoDates: false,
                                                                                    minDate: (0,date_helper/* getRcMinDate */.D$)(watchRcPickupDate),
                                                                                    startDate: watchRcDropoffDate,
                                                                                    onChange: function(_, param) {
                                                                                        var startDate = param.startDate;
                                                                                        if (startDate) {
                                                                                            setIsRcDropoffCalendarOpen(false);
                                                                                            disableShadowState();
                                                                                        }
                                                                                        setValue("rcDropoffDate", startDate || "");
                                                                                    },
                                                                                    useDefaultFooter: true,
                                                                                    onDismiss: function() {
                                                                                        setIsRcDropoffCalendarOpen(false);
                                                                                        disableShadowState();
                                                                                    }
                                                                                })
                                                                            ]
                                                                        });
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                px: 2,
                                                                mt: 3,
                                                                width: [
                                                                    1 / 2,
                                                                    null,
                                                                    1 / 4
                                                                ],
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShadowEffect/* default */.ZP, {
                                                                    enabled: true,
                                                                    forProperty: "rcDropoffTime",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeField, {
                                                                        id: "rc-dropoff-time",
                                                                        name: "rcDropoffTime",
                                                                        "data-testid": "packages-rc-dropoff-time",
                                                                        label: "Drop-off Time",
                                                                        ref: register,
                                                                        style: {
                                                                            height: isMobile ? "46px" : "56px"
                                                                        },
                                                                        value: watchRcDropoffTime,
                                                                        onChange: function(e) {
                                                                            setValue("rcDropoffTime", e.currentTarget.value);
                                                                            e.target.blur();
                                                                        }
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                flexWrap: "wrap",
                                                width: [
                                                    1,
                                                    null,
                                                    null,
                                                    null,
                                                    1
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            1 / 2
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, (0,_object_spread/* default */.Z)({
                                                            buttonText: buttonText,
                                                            isMobile: isMobile,
                                                            "data-testid": "find-your-trip-button"
                                                        }, rudderstack))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                        width: [
                                                            1,
                                                            null,
                                                            0.4
                                                        ],
                                                        px: 2,
                                                        mt: 3,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                            fontSize: "12px",
                                                            mt: 2,
                                                            children: callToAction
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !(0,TripTypes/* isHotelPlusCar */.Up)(watchTripType) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        flexDirection: "column",
                                        width: [
                                            1,
                                            null,
                                            null,
                                            null,
                                            1 / 3
                                        ],
                                        px: 2,
                                        mt: 3,
                                        ml: "auto",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFormButton/* default */.Z, (0,_object_spread/* default */.Z)({
                                                buttonText: buttonText,
                                                isMobile: isMobile,
                                                "data-testid": "find-your-trip-button"
                                            }, rudderstack)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                                fontSize: "12px",
                                                mt: 2,
                                                children: callToAction
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            });
        }
    });
};
/* harmony default export */ var SearchForm_Form = (Form);


/***/ }),

/***/ 12058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PackagesCarousel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./src/components/ScrollableDealModule/index.tsx + 1 modules
var ScrollableDealModule = __webpack_require__(89162);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/dist/build/polyfills/fetch/index.js
var fetch = __webpack_require__(63144);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);
;// CONCATENATED MODULE: ./src/hooks/useFetchPackages.ts






var PACKAGE_DISPLAY_MINIMUM = 3;
var PACKAGE_PRICE_CACHE_ENDPOINT = "/pws/v0/psapi/search/pricecache";
function setDealContent(deals) {
    return deals.map(function(deal) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, deal), {
            id: "PACKAGE_DEAL_".concat(deal.cityName.slice(-2)),
            image: deal.cityImageUrl,
            imageHeight: "284px",
            gaCategory: "PACKAGES_LANDING",
            gaAction: "Cached Deal",
            strikePrice: deal.priceAmount < deal.retailPriceAmount ? deal.retailPriceAmount : 0,
            gaLabel: deal.cityName,
            navArray: [
                {
                    href: deal.searchLink,
                    target: "_blank"
                }
            ]
        });
    });
}
var useFetchPackages = function(param) {
    var latitude = param.latitude, longitude = param.longitude;
    var queryString = latitude !== null && longitude !== null ? "?latitude=".concat(latitude, "&longitude=").concat(longitude) : "";
    var url = "".concat(PACKAGE_PRICE_CACHE_ENDPOINT).concat(queryString);
    var ref = (0,react.useState)([]), deals = ref[0], setDeals = ref[1];
    var ref1 = (0,react.useState)(true), didFetchSucceed = ref1[0], setFetchSucceeded = ref1[1];
    (0,react.useEffect)(function() {
        var fetchPackageDeals = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var priceCacheResponse, priceCacheJson, _packages, packages, packageDeals;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return fetch_default()(url, {
                                headers: {
                                    "Cache-Control": "private, max-age=900"
                                }
                            });
                        case 3:
                            priceCacheResponse = _ctx.sent;
                            _ctx.next = 6;
                            return priceCacheResponse.json();
                        case 6:
                            priceCacheJson = _ctx.sent;
                            _packages = priceCacheJson.packages, packages = _packages === void 0 ? [] : _packages;
                            if (!(!Array.isArray(packages) || packages.length < PACKAGE_DISPLAY_MINIMUM)) {
                                _ctx.next = 10;
                                break;
                            }
                            throw new Error("API call failed or not enough packages to display");
                        case 10:
                            setFetchSucceeded(true);
                            packageDeals = setDealContent(packages);
                            setDeals(packageDeals);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            setFetchSucceeded(false);
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchPackageDeals() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchPackageDeals();
    }, [
        url
    ]);
    return {
        deals: deals,
        didFetchSucceed: didFetchSucceed
    };
};
/* harmony default export */ var hooks_useFetchPackages = (useFetchPackages);

// EXTERNAL MODULE: ./src/hooks/useGeoPosition.ts
var useGeoPosition = __webpack_require__(29657);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: translateX(-200px)\n  }\n  100% {\n    transform: translateX(",
        "px)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #eee;\n  background-size: 200px 100%;\n  background-repeat: no-repeat;\n  display: inline-block;\n  line-height: 1;\n  width: ",
        ";\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background-image: linear-gradient(\n    to right,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  background-image: -webkit-linear-gradient(\n    left,\n    rgba(245, 245, 245, 0) 0%,\n    rgba(245, 245, 245, 1) 50%,\n    rgba(245, 245, 245, 0) 100%\n  );\n  animation: ",
        " 1.2s ease-in-out infinite;\n  height: 100%;\n  width: 200px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var animation = function(param) {
    var animationWidth = param.animationWidth;
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), animationWidth);
};
var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-50412902-0"
})(_templateObject1(), function(props) {
    return props.width ? props.width : "100%";
}, function(props) {
    return props.height && "height: ".concat(props.height, ";");
});
var Glare = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-50412902-1"
})(_templateObject2(), animation);
var Skeleton = function(param) {
    var height = param.height, width = param.width, _animationWidth = param.animationWidth, animationWidth = _animationWidth === void 0 ? 100 : _animationWidth;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
        height: height,
        width: width,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Glare, {
            animationWidth: animationWidth + 200,
            children: "‌"
        })
    });
};
/* harmony default export */ var components_Skeleton = (Skeleton);

;// CONCATENATED MODULE: ./src/components/DealCarouselLoader/index.tsx

function DealCarouselLoader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 379px;\n"
    ]);
    DealCarouselLoader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ItemFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-b533abb7-0"
})(DealCarouselLoader_templateObject());
var ItemCard = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
        p: 3,
        boxShadowSize: "sm",
        borderWidth: 0,
        width: [
            1,
            null,
            null,
            1 / 3
        ],
        mx: [
            null,
            null,
            null,
            2
        ],
        my: [
            2,
            null
        ],
        borderRadius: "xl",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    mb: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                        height: "200px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            mb: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Skeleton, {
                                height: "20px"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var DealCarouselLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        maxWidth: 1200,
        "data-testid": "deal-carousel-loader",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            px: 3,
            py: 1,
            width: 1,
            borderWidth: 0,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemFlex, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemCard, {})
                ]
            })
        })
    });
};
/* harmony default export */ var components_DealCarouselLoader = (DealCarouselLoader);

;// CONCATENATED MODULE: ./src/components/PackagesCarousel/index.tsx







var PackagesCarousel = function(param) {
    var _heading = param.heading, heading = _heading === void 0 ? "Don't miss these package deals" : _heading, _headingMobile = param.headingMobile, headingMobile = _headingMobile === void 0 ? "Don't miss these deals" : _headingMobile, rudderstack = param.rudderstack;
    var ref = (0,useGeoPosition/* default */.Z)(), longitude = ref.longitude, latitude = ref.latitude;
    var ref1 = hooks_useFetchPackages({
        latitude: latitude,
        longitude: longitude
    }), deals = ref1.deals, didFetchSucceed = ref1.didFetchSucceed;
    return didFetchSucceed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: 1280,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: 3,
                mt: 4,
                children: deals.length >= PACKAGE_DISPLAY_MINIMUM ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule/* default */.Z, {
                    content: {
                        heading: heading,
                        headingMobile: headingMobile,
                        dataArray: deals
                    },
                    handleNavOnClick: function(href) {
                        return window.open(href);
                    },
                    rudderstack: rudderstack
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_DealCarouselLoader, {})
            })
        })
    }) : null;
};
/* harmony default export */ var components_PackagesCarousel = (PackagesCarousel);


/***/ }),

/***/ 89162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_ScrollableDealModule; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var _create_super = __webpack_require__(25171);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/theme/theme.js + 1 modules
var theme = __webpack_require__(15072);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Card/Card.js
var Card = __webpack_require__(70609);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Hide/Hide.js
var Hide = __webpack_require__(87709);
// EXTERNAL MODULE: ./node_modules/@pcln/content-tile/dist/esm/index.js + 3 modules
var esm = __webpack_require__(60034);
// EXTERNAL MODULE: ./node_modules/@pcln/price-box/dist/esm/index.js + 11 modules
var dist_esm = __webpack_require__(46364);
// EXTERNAL MODULE: ./src/utils/analytics.ts
var analytics = __webpack_require__(94738);
// EXTERNAL MODULE: ./src/utils/rudder-stack.ts
var rudder_stack = __webpack_require__(964);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Button/Button.js
var Button = __webpack_require__(8316);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowUp.js
var ArrowUp = __webpack_require__(25192);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowDown.js
var ArrowDown = __webpack_require__(79016);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowLeft.js
var ArrowLeft = __webpack_require__(88410);
// EXTERNAL MODULE: ./node_modules/pcln-icons/dist/esm/ArrowRight.js
var ArrowRight = __webpack_require__(91209);
;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/ArrowButton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 40px;\n  width: 40px;\n\n  &&& {\n    border-radius: 50%;\n    padding: 8px 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var RoundButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-8220fd98-0"
})(_templateObject());
var iconLookup = {
    up: ArrowUp/* default */.Z,
    down: ArrowDown/* default */.Z,
    left: ArrowLeft/* default */.Z,
    right: ArrowRight/* default */.Z
};
var ArrowButton = function(_param) {
    var direction = _param.direction, disabled = _param.disabled, onClick = _param.onClick, label = _param.label, props = (0,_object_without_properties/* default */.Z)(_param, [
        "direction",
        "disabled",
        "onClick",
        "label"
    ]);
    var IconDirection = iconLookup[direction];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RoundButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        disabled: disabled,
        onClick: onClick,
        "data-testid": "arrow".concat(direction),
        "aria-label": label,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconDirection, {})
    }));
};
/* harmony default export */ var ScrollableDealModule_ArrowButton = (ArrowButton);

;// CONCATENATED MODULE: ./src/components/ScrollableDealModule/index.tsx







function ScrollableDealModule_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n"
    ]);
    ScrollableDealModule_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration-line: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

/* eslint-disable react/destructuring-assignment */ 







var RemainingWidthFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2e0c17ad-0"
})(ScrollableDealModule_templateObject());
var NoWrapText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.ZP).withConfig({
    componentId: "sc-2e0c17ad-1"
})(_templateObject1(), theme/* mediaQueries.1 */.w5[1]);
var NoDecorationLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).withConfig({
    componentId: "sc-2e0c17ad-2"
})(_templateObject2());
var TextSpan = Text/* default.span */.ZP.span;
var getImageTile = function(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ImageTile */.a5, {
                height: data.imageHeight,
                image: data.image,
                imageWebP: data.imageWebP,
                navArray: data.navArray,
                handleNavOnClick: isUsingNavArrows && handleNavOnClick,
                isOpaque: isOpaque,
                borderRadius: "xl",
                rounded: "top"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.ZP, {
                color: "text",
                p: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                fontSize: 0,
                                children: data.productName
                            }),
                            !!data.strikePrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* StrikePrice */.Ch, {
                                price: data.strikePrice,
                                size: "small"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justifyContent: "space-between",
                        alignItems: "baseline",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                        fontSize: 3,
                                        fontWeight: "bold",
                                        children: data.cityName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                        fontSize: 0,
                                        mt: 1,
                                        children: data.description
                                    })
                                ]
                            }),
                            !!data.priceAmount && /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWrapText, {
                                mt: "1px",
                                ml: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    alignItems: "baseline",
                                    children: [
                                        isUsingPricePrefix && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSpan, {
                                            mx: 2,
                                            color: "pricePrimary",
                                            fontSize: 4,
                                            fontWeight: "bold",
                                            children: data.pricePrefix
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_esm/* PriceBox */.bz, {
                                            priceSize: "small",
                                            price: data.priceAmount,
                                            priceColor: "pricePrimary",
                                            priceType: isUsingPriceType && "per person",
                                            alignItems: "right",
                                            toFixDecimal: 0
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
// TODO: improve the list of params using "deeper" React pattern
var parseDealTiles = function(dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, position, numDealsToDisplay, isTrips, handleNavOnClick, rudderstack) {
    var items = dataArray.slice(position, position + numDealsToDisplay);
    return items.map(function(data, index) {
        if (rudderstack) {
            (0,rudder_stack/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rudderstack), {
                position: position + 1 + index,
                category: "impression"
            }));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
            onClick: function() {
                analytics/* default.fireEvent */.Z.fireEvent({
                    action: data.gaAction,
                    category: data.gaCategory,
                    label: data.cityName
                });
                if (rudderstack) {
                    (0,rudder_stack/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rudderstack), {
                        position: position + 1 + index,
                        category: "click"
                    }));
                }
            },
            mx: [
                0,
                2
            ],
            mb: index === dataArray.length - 1 ? 0 : [
                3,
                0
            ],
            borderRadius: "xl",
            boxShadowSize: "md",
            borderWidth: 0,
            width: [
                1,
                1 / numDealsToDisplay
            ],
            "data-testid": "deal-tile-".concat(data.cityName),
            children: isTrips ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                onClick: data.onTileClick,
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NoDecorationLink, {
                href: data.navArray[0].href,
                target: "_blank",
                children: getImageTile(data, isUsingNavArrows, isUsingPricePrefix, isUsingPriceType, isOpaque, handleNavOnClick)
            })
        }, "deal-tile-".concat(data.cityName));
    });
};
var ScrollableDealModule = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ScrollableDealModule, _Component);
    var _super = (0,_create_super/* default */.Z)(ScrollableDealModule);
    function ScrollableDealModule(props) {
        (0,_class_call_check/* default */.Z)(this, ScrollableDealModule);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            position: 0,
            numDealsToDisplay: 0
        };
        _this.handleLeftArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), false);
        _this.handleRightArrowClick = _this.updatePosition.bind((0,_assert_this_initialized/* default */.Z)(_this), true);
        _this.handleResize = _this.handleResize.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    var _proto = ScrollableDealModule.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            numDealsToDisplay: // eslint-disable-next-line no-nested-ternary
            window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1
        });
        window.addEventListener("resize", this.handleResize);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    };
    _proto.handleResize = function handleResize() {
        var screenSize = window.innerWidth;
        if (screenSize >= 1024 && this.state.numDealsToDisplay !== 3) {
            this.setState({
                numDealsToDisplay: 3
            });
        } else if (screenSize >= 640 && screenSize < 1024 && this.state.numDealsToDisplay !== 2) {
            this.setState({
                numDealsToDisplay: 2
            });
        } else if (screenSize < 640 && this.state.numDealsToDisplay !== 1) {
            this.setState({
                numDealsToDisplay: 1
            });
        }
    };
    _proto.updatePosition = function updatePosition(shouldAdd) {
        if (shouldAdd) {
            var maxIndex = this.props.content.dataArray.length - this.state.numDealsToDisplay;
            var nextPosition = this.state.position + this.state.numDealsToDisplay;
            var position = Math.min(nextPosition, maxIndex);
            this.setState({
                position: position
            });
        } else {
            var nextPosition1 = this.state.position - this.state.numDealsToDisplay;
            var position1 = Math.max(nextPosition1, 0);
            this.setState({
                position: position1
            });
        }
    };
    _proto.render = function render() {
        var _props = this.props, content = _props.content, handleNavOnClick = _props.handleNavOnClick, _isUsingNavArrows = _props.isUsingNavArrows, isUsingNavArrows = _isUsingNavArrows === void 0 ? true : _isUsingNavArrows, _isUsingPriceType = _props.isUsingPriceType, isUsingPriceType = _isUsingPriceType === void 0 ? true : _isUsingPriceType, _isUsingPricePrefix = _props.isUsingPricePrefix, isUsingPricePrefix = _isUsingPricePrefix === void 0 ? false : _isUsingPricePrefix, _isOpaque = _props.isOpaque, isOpaque = _isOpaque === void 0 ? true : _isOpaque, _isTrips = _props.isTrips, isTrips = _isTrips === void 0 ? false : _isTrips, rudderstack = _props.rudderstack;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    px: 3,
                    pb: 24,
                    fontSize: 4,
                    fontWeight: "bold",
                    m: 0,
                    color: "text.heading",
                    textStyle: "heading2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: content.heading
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            sm: true,
                            md: true,
                            lg: true,
                            xl: true,
                            xxl: true,
                            children: content.headingMobile
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    children: [
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "left",
                                mr: 3,
                                disabled: this.state.position === 0,
                                onClick: this.handleLeftArrowClick,
                                label: "Scroll backward through the deals"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RemainingWidthFlex, {
                            flexDirection: [
                                "column",
                                "row"
                            ],
                            mx: 2,
                            children: parseDealTiles(content.dataArray, isUsingNavArrows, isUsingPriceType, isUsingPricePrefix, isOpaque, this.state.position, this.state.numDealsToDisplay, isTrips, handleNavOnClick, rudderstack)
                        }),
                        isUsingNavArrows && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hide/* default */.Z, {
                            xs: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableDealModule_ArrowButton, {
                                color: "primary",
                                direction: "right",
                                disabled: this.state.position >= content.dataArray.length - this.state.numDealsToDisplay,
                                onClick: this.handleRightArrowClick,
                                label: "Scroll forward through the deals"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return ScrollableDealModule;
}(react.Component);
/* harmony default export */ var components_ScrollableDealModule = (ScrollableDealModule);


/***/ }),

/***/ 29657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68464);


var useGeoPosition = function() {
    var locale = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_BootstrapDataContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.longitude ? locale.longitude : null), longitude = ref[0], setLongitude = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(locale.latitude ? locale.latitude : null), latitude = ref1[0], setLatitude = ref1[1];
    var onSuccess = function(param) {
        var coords = param.coords;
        setLongitude(coords.longitude);
        setLatitude(coords.latitude);
    };
    var onError = function() {
    // TODO: fail silently or log error
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var geo = navigator.geolocation;
        if (!geo) {
            // TODO: potentially log error
            return;
        }
        geo.getCurrentPosition(onSuccess, onError);
    }, []);
    return {
        longitude: longitude,
        latitude: latitude
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGeoPosition);


/***/ })

}]);